export default "__VITE_ASSET__CdHrhb1S__"